import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getPaymentDetails } from "../../../api/paymentApi";
import CountUp from "react-countup";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      loading: false,
      paymentSummary: {},
      chartData: [],
    };
  }

  fetchPaymentDetails = async () => {
    try {
      const response = await getPaymentDetails();

      if (response.success) {
        const data = response.data;

        this.setState({
          paymentSummary: data,
          chartData: [
            {
              name: "Successful",
              value: data.successfulPayments || 0,
            },
            {
              name: "Pending",
              value: data.pendingPayments || 0,
            },
            {
              name: "Failed",
              value: data.failedPayments || 0,
            },
          ],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  componentDidMount() {
    this.fetchPaymentDetails();
  }

  render() {
    const COLORS = ["#55DD75", "#EAE26C", "#FC8D98"];
    const { fixNavbar } = this.props;
    return (
      <>
        <div>
          <div className={`section-body ${fixNavbar ? "marginTop" : ""} mt-3`}>
            <div className="container-fluid">
              <div className="row clearfix">
                <div className="col-lg-12">
                  <div
                    className={`section-body ${
                      fixNavbar ? "mb-4 mt-3" : "mb-4"
                    }`}
                  >
                    <h4>Welcome Jason Porter!</h4>
                    <small>
                      Measure How Fast You’re Growing Monthly Recurring Revenue.{" "}
                      <a href="fake_url">Learn More</a>
                    </small>
                  </div>
                </div>
              </div>
             <div className="row clearfix">
  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body ribbon">
        <div className="ribbon-box green">5</div>
        <Link to="/users" className="my_sort_cut text-dark">
          <i className="icon-users" />
          <span>Users</span>
        </Link>
      </div>
    </div>
  </div>

  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body">
        <Link to="/recent-pay" className="my_sort_cut text-dark">
          <i className="icon-wallet" />
          <span>Recent Pay</span>
        </Link>
      </div>
    </div>
  </div>

  {/*
  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body ribbon">
        <div className="ribbon-box orange">8</div>
        <Link to="/hr-events" className="my_sort_cut text-dark">
          <i className="icon-calendar" />
          <span>Events</span>
        </Link>
      </div>
    </div>
  </div>

  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body">
        <Link to="/hr-payroll" className="my_sort_cut text-dark">
          <i className="icon-credit-card" />
          <span>Payroll</span>
        </Link>
      </div>
    </div>
  </div>

  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body">
        <Link to="/hr-accounts" className="my_sort_cut text-dark">
          <i className="icon-calculator" />
          <span>Accounts</span>
        </Link>
      </div>
    </div>
  </div>

  <div className="col-6 col-md-4 col-xl-2">
    <div className="card">
      <div className="card-body">
        <Link to="/hr-report" className="my_sort_cut text-dark">
          <i className="icon-pie-chart" />
          <span>Report</span>
        </Link>
      </div>
    </div>
  </div>
  */}
</div>

              <div className="row clearfix">
                <div className="card-header">
                  <h5 className="card-title">Payment Status Overview</h5>
                </div>

                <div className="col-md-3">
                  <div className="card">
                    <div className="card-body text-center">
                      <h6>Total Transactions</h6>
                      <h3>
                        <CountUp
                          end={this.state.paymentSummary.totalTransactions || 0}
                          duration={2}
                        />
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="card">
                    <div className="card-body text-center">
                      <h6>Successful</h6>
                      <h3>
                        <CountUp
                          end={
                            this.state.paymentSummary.successfulPayments || 0
                          }
                          duration={2}
                        />
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="card">
                    <div className="card-body text-center">
                      <h6>Pending</h6>
                      <h3>
                        <CountUp
                          end={this.state.paymentSummary.pendingPayments || 0}
                          duration={2}
                        />
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="card">
                    <div className="card-body text-center">
                      <h6>Failed</h6>
                      <h3>
                        <CountUp
                          end={this.state.paymentSummary.failedPayments || 0}
                          duration={2}
                        />
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix mt-4">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <ResponsiveContainer width="100%" height={400}>
                        <PieChart>
                          <Pie
                            data={this.state.chartData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            outerRadius={140}
                            fill="#8884d8"
                            dataKey="value"
                            label={({ name, value }) => `${name}: ${value}`}
                          >
                            {this.state.chartData.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                              />
                            ))}
                          </Pie>

                          <Tooltip />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
